import { FaTools, FaCogs, FaWrench, FaHeadset, FaTruck, FaShieldAlt, FaCheck, FaWhatsapp } from 'react-icons/fa';
import '../styles/services.css';

const Services = () => {
  const services = [
    {
      icon: <FaTools className="service-icon service-icon-blue" />,
      title: 'Jiko Sales',
      description: 'We offer a wide range of high-quality jikos for both domestic and commercial use. Our products are designed for efficiency, durability, and environmental friendliness.',
      features: [
        'Energy-efficient designs',
        'Various sizes and models',
        'Eco-friendly options',
        'Competitive pricing'
      ]
    },
    {
      icon: <FaCogs className="service-icon service-icon-red" />,
      title: 'Installation Services',
      description: 'Our certified technicians provide professional installation services to ensure your jiko or motor equipment is set up correctly and safely.',
      features: [
        'Expert installation',
        'Safety compliance',
        'Testing and calibration',
        'User training'
      ]
    },
    {
      icon: <FaWrench className="service-icon service-icon-green" />,
      title: 'Maintenance & Repairs',
      description: 'Regular maintenance and timely repairs are essential for the longevity and efficiency of your equipment. Trust our skilled technicians for all your maintenance needs.',
      features: [
        'Routine maintenance',
        'Emergency repairs',
        'Genuine spare parts',
        'Performance optimization'
      ]
    },
    {
      icon: <FaTruck className="service-icon service-icon-yellow" />,
      title: 'Supply & Distribution',
      description: 'We supply and distribute a wide range of motor equipment and spare parts from trusted manufacturers.',
      features: [
        'Wide product range',
        'Bulk supply options',
        'Nationwide delivery',
        'Competitive pricing'
      ]
    },
    {
      icon: <FaHeadset className="service-icon service-icon-purple" />,
      title: 'Technical Support',
      description: 'Our dedicated support team is available 24/7 to assist you with any technical issues or questions you may have.',
      features: [
        '24/7 support',
        'Remote troubleshooting',
        'Expert advice',
        'Quick response times'
      ]
    },
    {
      icon: <FaShieldAlt className="service-icon service-icon-orange" />,
      title: 'Warranty & After-Sales',
      description: 'We stand behind our products and services with comprehensive warranty coverage and reliable after-sales support.',
      features: [
        'Extended warranties',
        'Regular follow-ups',
        'Maintenance contracts',
        'Customer satisfaction guarantee'
      ]
    }
  ];

  const process = [
    {
      step: '1',
      title: 'Consultation',
      description: 'Discuss your requirements with our experts',
      icon: (
        <div className="process-step-number process-step-blue">
          1
        </div>
      )
    },
    {
      step: '2',
      title: 'Site Assessment',
      description: 'We evaluate your specific needs and site conditions',
      icon: (
        <div className="process-step-number process-step-green">
          2
        </div>
      )
    },
    {
      step: '3',
      title: 'Proposal',
      description: 'Receive a detailed quote and service plan',
      icon: (
        <div className="process-step-number process-step-yellow">
          3
        </div>
      )
    },
    {
      step: '4',
      title: 'Implementation',
      description: 'Professional installation and setup by our team',
      icon: (
        <div className="process-step-number process-step-red">
          4
        </div>
      )
    },
    {
      step: '5',
      title: 'Support',
      description: 'Ongoing maintenance and support services',
      icon: (
        <div className="process-step-number process-step-purple">
          5
        </div>
      )
    }
  ];

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="services-hero-container">
          <h1 className="services-hero-title">Our Services</h1>
          <p className="services-hero-subtitle">
            Comprehensive solutions for all your jiko and motor equipment needs
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-section">
        <div className="services-container">
          <div className="section-header">
            <h2 className="section-title">What We Offer</h2>
            <div className="section-divider"></div>
            <p className="section-description">
              We provide a wide range of services to meet all your jiko and motor equipment requirements.
            </p>
          </div>
          
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-card-content">
                  <div className="service-card-inner">
                    {service.icon}
                    <h3 className="service-card-title">{service.title}</h3>
                    <p className="service-card-description">{service.description}</p>
                    <ul className="service-features">
                      {service.features.map((feature, i) => (
                        <li key={i} className="service-feature">
                          <FaCheck className="feature-icon" />
                          <span className="feature-text">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="service-card-footer">
                  <a
                    href="https://wa.me/254721858828"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="service-cta-button"
                  >
                    <FaWhatsapp className="whatsapp-icon" /> Enquire Now
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="process-container">
          <div className="section-header">
            <h2 className="section-title">Our Process</h2>
            <div className="section-divider"></div>
            <p className="section-description">
              We follow a structured approach to ensure the best results for our clients
            </p>
          </div>
          
          <div className="process-timeline">
            <div className="process-line"></div>
            <div className="process-steps">
              {process.map((step, index) => (
                <div key={index} className="process-step">
                  {step.icon}
                  <h3 className="process-step-title">{step.title}</h3>
                  <p className="process-step-description">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <div className="cta-container">
          <h2 className="cta-title">Need Our Services?</h2>
          <p className="cta-subtitle">
            Contact us today to discuss your jiko and motor equipment needs with our experts.
          </p>
          <div className="cta-buttons">
            <a
              href="https://wa.me/254721858828"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button cta-button-primary"
            >
              <FaWhatsapp className="whatsapp-icon" /> Chat on WhatsApp
            </a>
            <a
              href="tel:+254721858828"
              className="cta-button cta-button-secondary"
            >
              Call Us Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
